import { motion } from 'motion/react'
import type { ReactNode } from 'react'
import { pageTransition } from '~/lib/utils/animations'
import { PageLayout } from './PageLayout'

type WebsiteLayoutProps = {
  children: ReactNode
  className?: string
  showHero?: boolean
  heroContent?: ReactNode
}

export const WebsiteLayout = ({
  children,
  className = '',
  showHero = false,
  heroContent,
}: WebsiteLayoutProps) => {
  return (
    <PageLayout>
      <motion.div
        initial="initial"
        animate="animate"
        exit="exit"
        variants={pageTransition}
        className={className}
      >
        {showHero && (
          <div className="relative overflow-hidden bg-[#001871] text-white">
            {/* Enhanced texture overlay */}
            <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1584036561566-baf8f5f1b144?ixlib=rb-4.0.3')] opacity-5 mix-blend-soft-light"></div>
            <div className="absolute inset-0 bg-linear-to-b from-[#001871] via-[#001871] to-[#001871]/90"></div>

            {/* Abstract shapes with improved contrast */}
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 0.15, scale: 1 }}
              transition={{ duration: 2 }}
              className="absolute left-20 top-20 size-96 rounded-full bg-white blur-3xl"
            />
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 0.15, scale: 1 }}
              transition={{ duration: 2, delay: 0.5 }}
              className="absolute bottom-20 right-20 size-96 rounded-full bg-white blur-3xl"
            />

            <div className="relative py-24">
              <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">{heroContent}</div>
            </div>
          </div>
        )}
        {children}
      </motion.div>
    </PageLayout>
  )
}
